module.exports = __webpack_public_path__ + "static/img/point_text3.0217451.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/point_text3.png
// module id = zlJq
// module chunks = 1